import { Stack } from '@mui/material';
import { CommentFragment } from '../generated/graphql';
import { CommentCard } from './comment-card';
import React from 'react';

interface CommentListProps {
  comments: CommentFragment[];
  onDelete: (comment: CommentFragment) => void;
  onEdit: (commentId: string, comment: string) => void;
  disabled?: boolean;
}

export const CommentList = ({ comments, onDelete, onEdit, disabled }: CommentListProps) => {
  const sorted = React.useMemo(() => {
    return [...comments].sort((a, b) => {
      return b.createdAt > a.createdAt ? 1 : -1;
    });
  }, [comments]);
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {sorted.map((note) => (
        <CommentCard key={note.id} comment={note} onDelete={onDelete} onEdit={onEdit} disabled={disabled} />
      ))}
    </Stack>
  );
};
